<mat-form-field appearance="outline" class="{{displayClass}}">
  @if(label){
  <mat-label>{{ label }}</mat-label>
  }
  <input matInput [formControl]="formControl" [placeholder]="placeholder" [maxlength]="maxLength" [attr.type]="type"
    [min]="min" [max]="max" [required]="required" [attr.name]="name" [matAutocomplete]="auto"
    (keydown)="onEnterPress($event)">
  @if(prefix){
  <span matPrefix><nuc-icon color="iconColor" iconClass="{{prefix}}"></nuc-icon></span>
  }
  @if(suffix){
  <span matSuffix><nuc-icon color="iconColor" iconClass="{{suffix}}" (click)="clearInput()"></nuc-icon></span>
  }
  @if(hint){
  <mat-hint align="start">{{hint}}</mat-hint>
  }
  <mat-autocomplete class="custom-mat-autocomplete" autoActiveFirstOption #auto="matAutocomplete"
    (optionSelected)="onOptionSelected($event)">
    @if(formControl.value){
    @if(filteredOptions && filteredOptions.length > 0){
    @if(filterKeys){
    @for (option of filteredOptions; track $index) {
    <mat-option [value]="option.label">
      <div *ngIf="option.dealerCode">{{option.dealerCode}} - {{option.dealerShipName}}</div>
      <div class="label-wrapper">
        <span [innerHTML]="highlightMatch(option.label)"></span>
        <nuc-icon *ngIf="option.linkType === 'newTab'" iconClass="stla-externalLink"></nuc-icon>
      </div>
      <div *ngIf="userType === 'LeapMotor'" class="description">
        <!-- NEW: Breadcrumb/context line (parent > child) -->
        <div class="context" *ngIf="(option.parentMenuLabel || option.childMenuLabel)">
          <span class="context-text">
            <span *ngIf="option.parentMenuLabel" [innerHTML]="highlightMatch(option.parentMenuLabel)"></span>
            <span *ngIf="option.parentMenuLabel && option.childMenuLabel"> &gt; </span>
            <span *ngIf="option.childMenuLabel" [innerHTML]="highlightMatch(option.childMenuLabel)"></span>
          </span>
        </div>
      </div>
      <div *ngIf="option.linkDescription && userType != 'LeapMotor'" class="description">
        <span [innerHTML]="highlightMatch(option.linkDescription)"></span>
      </div>
    </mat-option>
    }
    }
    @else{
    <mat-option>
      Showing Results for
      '<span [innerHTML]="highlightMatch(formControl.value)">{{formControl.value}}</span>'
    </mat-option>
    @for (option of filteredOptions; track option) {
    <mat-option [value]="option" [innerHTML]="highlightMatch(option)">{{option}}</mat-option>
    }
    }
    } @else {
    <mat-option class="error-message-container">
      <nuc-icon class="info-icon" iconClass="info_outlined" color="#1C1B1F"
        size="64 material-icons-outlined"></nuc-icon>
      <p class="info-message-text">There are no results for your search '{{formControl.value}}'</p>
    </mat-option>
    }
    }
  </mat-autocomplete>
</mat-form-field>